module.exports = __webpack_public_path__ + "fonts/Inter-300-latin42.8e433c0.woff2";